import { ReceiptFacts, ReceiptLinesTable, ReceiptPaymentKindText, StatusMessage } from '@krp/ui-kit'
import { formatDateTime, formatMoney, formatQuantity } from '../../pricing/model/format'
import type { CashReceiptDetails } from '../model/types'

export interface CashReceiptDetailProps {
  data: CashReceiptDetails | undefined
  error: string | null
  /** Карточка товара 1С по ключу номенклатуры — та же, что из списка номенклатуры. */
  openProduct: (productKey: string) => void
  /** Главное фото товара по ключу номенклатуры. */
  photoOf: (productKey: string) => string
}

/** Окно чека 1С: шапка таблицей «подпись — значение», ниже товары чека — компактной таблицей, как список номенклатуры. */
export function CashReceiptDetailScreen({ data, error, openProduct, photoOf }: CashReceiptDetailProps) {
  if (error !== null) return <StatusMessage kind="error" title="Не удалось прочитать чек" text={error} />
  if (data === undefined) return <StatusMessage kind="loading" title="Читаем исходный чек…" />
  const receipt = data.receipt
  const cash = receipt.amount === null || receipt.cardAmount === null ? null : Math.round((receipt.amount - receipt.cardAmount) * 100) / 100
  return <section className="onec-screen" aria-label="Исходный чек 1С">
    <ReceiptFacts label="Реквизиты чека" facts={[
      { label: 'Вид', value: receipt.kind === 'refund' ? 'Возврат' : 'Приход' },
      { label: 'Номер', value: receipt.receiptNumber ?? receipt.number ?? 'без номера' },
      { label: 'Дата и время', value: formatDateTime(receipt.date) },
      { label: 'Касса', value: receipt.registerName ?? 'не указана' },
      { label: 'Кассир', value: receipt.cashierName ?? 'не указан' },
      { label: 'Смена', value: receipt.shiftNumber ?? 'не указана' },
      { label: 'Оплата', value: <ReceiptPaymentKindText cash={cash} card={receipt.cardAmount} /> },
      { label: 'Наличными', value: formatMoney(cash) },
      { label: 'Картой', value: formatMoney(receipt.cardAmount) },
      { label: 'Итого', value: formatMoney(receipt.amount) },
      { label: 'Состояние', value: [receipt.status, receipt.posted ? 'проведён' : 'не проведён'].filter((part) => part !== null).join(' · ') },
    ]} />
    {data.lines.length === 0 ? <p>В чеке нет товаров</p> : <ReceiptLinesTable lines={data.lines.map((line) => {
      const key = line.productKey
      return {
        id: String(line.lineNumber),
        name: line.productName ?? (key === null ? 'товар не указан' : 'товар не найден в 1С'),
        quantity: formatQuantity(line.quantity),
        price: formatMoney(line.price),
        amount: formatMoney(line.amount),
        discount: line.discount === null || line.discount === 0 ? null : formatMoney(line.discount),
        ...(key === null ? {} : { photo: photoOf(key), open: () => openProduct(key) }),
      }
    })} />}
  </section>
}
